<template>
    <div class="material-master" @click="closeDrawer" style="margin-bottom: 0;">
      <!-- <div class="material-master-bar v-center space-between px-3" style="background-color:aqua;"> -->
         <div class="header-container module-header">
                <h1 v-if="view === 'material'" class="module-name">Material Master</h1>
                <h1 v-else class="module-name">Resource Master</h1>
        <div class="flex filter-options">
          <div>
            <label for="">Sort By</label>
            <select v-model="selectedSort" class="sort" name="" id="">
              <option value="1">Latest</option>
              <option value="2">Oldest</option>
              <option value="3">Sort: A to Z</option>
              <option value="4">Sort: Z to A</option>
            </select>
          </div>
            <div class="mr-3">
            <button
              class="toggle toggle-left pointer"
              :class="{ 'toggle-selected': view === 'material' }"
              @click="changeView('material')"
            >
              Material
            </button>
            <button
              class="toggle toggle-right pointer"
              :class="{ 'toggle-selected': view === 'resource' }"
              @click="changeView('resource')"
            >
              Resource
            </button>
          </div>
          <!-- <button v-if="showImportMaterialButton" class="btn btn-brand mr-3 pointer" @click="openImportModal">
            Import Material
          </button> -->
                <button
                v-if="showAddMaterialButton && view === 'material'"
                class="btn btn-black mr-3 pointer"
                @click="openCreateMaterialModal"
                >
                + Add Material
            </button>
            <button
            v-else-if="showAddMaterialButton && view === 'resource'"
            class="btn btn-black mr-3 pointer"
            @click="openCreateMaterialModal"
            >
            + Add Resource
            </button>
          <button class="btn mr-3 pointer v-center" @click="downloadCsvData" v-tooltip="'Download csv file'">
            <img
      src="~@/assets/images/icons/download-icon.svg"
      alt=""
      width="16px"
      class="mr-1"
      />Export csv
          </button>
          <button @click.stop="toggleDrawer" class="btn addfilter v-center">
              <div v-if="getAppliedFilterNumber" class="addfilter-badge">{{ getAppliedFilterNumber}}</div>
              <div v-if="getAppliedFilterNumber" class="addfilter-ping"></div>
                  <img
      src="~@/assets/images/icons/filter-icon.svg"
      alt=""
      width="14"
      class="mr-1"
      /> Add Filter
          </button>
        </div>
    </div>
        <div class="material-master-action m flex">
          <div class="drawer" :class="drawer ? 'open' : 'close'" ref="drawer">
            <div class="filters relative" @click.stop>
              <div class="input-group m">
                <h5 class="filter-by">
                  Filter by Name, ID, Product Code, and Description
                </h5>
                <input
                  :class="{
                    selectedOne:  filtersTemp.searchKeyWord,
                  }"
                  type="text"
                  v-model="filtersTemp.searchKeyWord"
                  placeholder=" Filter by Name, ID, Product Code, and Description"
                />
              </div>
              <h5 class="filter-by mt-5">Filter By Tags:</h5>
              <filterTag
                :clear="clear"
                :tags="getTags"
                @new-tag="addNewTag"
                @clear="clearAllTags"
                @update-tags="updateTags"
                :type="1"
                title="Add tags to filter"
              />
              <span
                class="v-center mt-2 m underline pointer gap-1"
                v-if="moreFilter"
                @click="moreFilter = !moreFilter"
                >show less
                <img
                  src="~@/assets/images/icons/arrow-up-icon.svg"
                  height="15px"
                  alt=""
              /></span>
              <span
                class="v-center mt-2 m underline pointer gap-1"
                v-else
                @click="moreFilter = !moreFilter"
                >view more filters
                <img
                  src="~@/assets/images/icons/arrow-down-icon.svg"
                  height="15px"
                  alt=""
              /></span>
              <div v-if="moreFilter">
                <h5 class="filter-by mt-5" v-if="view === 'resource'">
                  Filter by Resource status :
                </h5>
                <single-select-drop-down
                  :clear="clear"
                  :options="resourceStateValues"
                  :current="selectedStatus"
                  @selected="addResourceSatatus"
                  :componentfor="'materialFilter'"
                  v-if="view === 'resource'"
                />
                <h5 class="filter-by">Lead Time :</h5>
                <div class="input-group-ind">
                  <label for="">From :</label>
                  <label for="">To :</label>
                  <input
                    type="number"
                    placeholder="From"
                     @change="updatedleadTimeFrom"
                    :value="filtersTemp.leadtime.from"
                    :class="{ selectedOne: filtersTemp.leadtime.from }"
                  />
                  <input
                    type="number"
                    placeholder="To"
                    @change="updatedleadTimeTo"
                    :value="filtersTemp.leadtime.to"
                    :min="filtersTemp.leadtime.from"
                    :class="{ selectedOne: filtersTemp.leadtime.to }"
                  />
                </div>
                <h5 class="filter-by">Effective Date:</h5>
                <div class="input-group-ind">
                  <label for="">From :</label>
                  <label for="">To :</label>
                  <input
                    type="date"
                    placeholder="From"
                     @change="updateEffectiveDateFrom"
                    :value="filtersTemp.effectiveDate.from"
                    :class="{ selectedOne: filtersTemp.effectiveDate.from }"
                  />
                  <input
                    type="date"
                    placeholder="To"
                    @change="updateEffectiveDateTo"
                    :value="filtersTemp.effectiveDate.to"
                    :min="filtersTemp.effectiveDate.from"
                    :class="{ selectedOne: filtersTemp.effectiveDate.to }"
                  />
                </div>

                <h5 class="filter-by">Filter By Custom-List:</h5>
                <filter-by-custom-list
                  :type="view"
                  :clear="clear"
                  :initial-values="customListItmes"
                  @filter-cusList="addCusListFilters"
                  :drawer="drawer"
                />
              </div>
            </div>
            <div class="v-center mt-3 space-between button-box">
              <span class="v-center gap-1">
                <button class="btn btn-black" @click="cancelFilter">
                  Cancel
                </button>
                <button class="btn" @click="clearAllData">Clear All</button></span
              >
              <button class="btn" @click="applyFilter">Apply</button>
            </div>
          </div>
        <!-- </div> -->
      </div>
      <copy-material-master-table
        :view="view"
        @updateList="updateList"
        :materialMasterList="materialMasterData"
        @selectPage="selectPage"
        :pageNumber="pageNumber"
        :perPage="perPage"
        :totalCount="totalCount"
      />
      <modal
        title="Import Material"
        :open="importMaterialModal"
        @close="closeImportModal"
      >
        <import-material v-if="importMaterialModal" @close="closeImportModal" />
      </modal>
      <modal
        :title="
          view === 'material' ? 'Create New Material' : 'Create New Resource'
        "
        :open="createNew"
        @close="materialCreated"
      >
        <create-material-master
          v-if="createNew"
          :view="view"
          :open="createNew"
          @created="materialCreated"
          @close="materialCreated"
        />
      </modal>
    </div>
  </template>

<script>
import { mapGetters, mapMutations } from 'vuex'
// import MaterialMasterTable from '../../components/materialMaster/materialMasterTable.vue'
import copyMaterialMasterTable from '../../components/materialMaster/copyMaterialMasterTable.vue'
import { generateS3DownloadingUrl, GetAllformFieldsOfAllVersionsByFormTypeId, GetAllSequenceTemplates, GetMaterialMasterData, ResourceState, searchExternalMaterials } from '@/api'
import Loader from '@/plugins/loader'
import { arrayToCsv } from '@/helper/file/arrayToCsv'
import Modal from '../../components/common/modal.vue'
import ImportMaterial from '../../components/materialMaster/importMaterial.vue'
// import { debounce } from '@/utils/debounce'
import CreateMaterialMaster from '../../components/materialMaster/createMaterialMaster.vue'
import filterTag from '../../components/common/filterTag.vue'
import FilterByCustomList from '../../components/common/filterByCustomList.vue'
import singleSelectDropDown from '../../components/common/singleSelectDropDown.vue'
import config from '@/config'
import { alert } from '@/plugins/notification'
import { startGlobalCursorLoader, stopGlobalCursorLoader } from '@/utils/globalCursorLoader'
export default {
  components: {
    Modal,
    ImportMaterial,
    CreateMaterialMaster,
    filterTag,
    FilterByCustomList,
    singleSelectDropDown,
    copyMaterialMasterTable
  },
  data: () => ({
    selectedSort: '1',
    view: 'material',
    totalCount: 0,
    pageNumber: 1,
    perPage: 20,
    materialMasterData: [],
    clear: false,
    searchKeyWord: '',
    importMaterialModal: false,
    updateOnSearch: null,
    createNew: false,
    drawer: false,
    customListItmes: null,
    effectiveDate: {
      from: null,
      to: null
    },
    leadtime: {
      from: null,
      to: null
    },
    moreFilter: false,
    resourceStateValues: [],
    selectedStatus: {},
    tagsFilter: [],
    filtersTemp: {
      searchKeyWord: '',
      customListItmes: {},
      effectiveDate: { from: null, to: null },
      leadtime: { from: null, to: null },
      tagsFilter: []
    }
  }),
  computed: {
    ...mapGetters(['user', 'getUserById', 'isOnProjectLevel', 'collaborator', 'openTenantId', 'isExternalCollaborator']),
    ...mapGetters('tag', ['getTags']),
    ...mapGetters('material', ['getFilters']),
    isCopyMM () {
      return this.$route.path.includes('copy-materialmaster')
    },
    showAddMaterialButton () {
      return (
        (this.user.tenantLevelRole === 'ADMIN' || this.user.tenantLevelRole === 'EDITOR' ||
            this.user.tenantLevelRole === 'COLLABORATOR') &&
          !this.isOnProjectLevel &&
          !this.collaborator
      )
    },
    showImportMaterialButton () {
      return (
        this.user.tenantLevelRole === 'ADMIN' ||
          this.user.tenantLevelRole === 'COLLABORATOR' ||
          this.user.tenantLevelRole === 'EDITOR'
      )
    },
    getAppliedFilterNumber () {
      let filterNo = 0
      if (this.getFilters.searchKeyWord) {
        filterNo++
      }
      if (this.tagsFilter.length > 0) {
        filterNo++
      }
      if (this.getFilters.lead?.from || this.getFilters.lead?.to) {
        filterNo++
      }
      if (this.getFilters?.date?.from || this.getFilters.effective?.date?.to) {
        filterNo++
      }
      if (this.getFilters.customListItmes) {
        filterNo += Object.values(this.getFilters?.customListItmes)?.length
      }
      if (!filterNo) {
        return false
      }
      return String(filterNo)?.padStart(2, '0')
    }
  },
  methods: {
    ...mapMutations('material', ['updateFilters']),
    openCreateMaterialModal () {
      startGlobalCursorLoader()
      GetAllSequenceTemplates(config.CORE_FEATURES.MATERIAL).then((res) => {
        if (res.core_sequence_id_template?.length) {
          this.createNew = true
        } else {
          alert('No sequence Id is associated with your tenant')
        }
      }).catch(() => {
        alert('Failed to fetch, please try again later')
      }).finally(() => {
        stopGlobalCursorLoader()
      })
    },
    transformExternalResults (results) {
      if (!results || !Array.isArray(results)) {
        return []
      }

      return results.map((item) => ({
        id: item.Item_No,
        custom_material_id: item.Item_No,
        material_name: item.Item_Description,
        material_description: item.Item_Description,
        erp_material_id: null,
        plm_material_id: null,
        unit_of_material: item.Sales_UoM ?? 'inch', // Default UOM: Inch (in)
        material_unit_details: { name: item.Sales_UoM ?? 'Inch (in)' }, // Required for table display
        product_code: item.item_group || null,
        material_product_code: item.item_group ? { product_code: item.item_group } : null,
        inventory: Math.trunc(item.In_Stock) || 0,
        unit_cost: item.price || 0,
        lead_time: null,
        gross_weight: null,
        weight_unit: null,
        material_weight_details: { name: null }, // Required for some operations
        storage_loc: null,
        material_storage_location: { name: null }, // Required for some operations
        material_group: null,
        material_group_details: { name: null }, // Required for export CSV
        resource_group_details: { name: null }, // Required for resource view
        resource_state_value: { id: null }, // Required for resource status dropdown
        material_source: { source: 'External Search' },
        material_status: { status: 'Active' },
        status: 1, // Active
        material_document_associations: [],
        tag_materials: [],
        core_form: { forms_metadata_by_id: [], forms_config_lists: [] },
        thumbnail_url: null,
        blob_reference_key: null,
        // Mark as external so we can handle it differently in UI if needed
        is_external_result: true,
        external_source_data: item
      }))
    },
    clearAllData () {
      this.updateFilters({})
      this.selectedStatus = {}
      this.clear = true
      this.searchKeyWord = ''
      this.leadtime.from = ''
      this.leadtime.to = ''
      this.effectiveDate.from = ''
      this.effectiveDate.to = ''
      this.customListItmes = null
      this.tagsFilter = []
      this.resetTempFilters()
      setTimeout(() => {
        this.clear = false
      }, 1000)
      this.fetchMaterialMasterData(1)
    },
    applyFilter () {
      const filtersTemp = JSON.parse(JSON.stringify(this.filtersTemp))
      this.searchKeyWord = filtersTemp.searchKeyWord
      this.customListItmes = filtersTemp.customListItmes
      this.leadtime = filtersTemp.leadtime
      this.effectiveDate = filtersTemp.effectiveDate
      this.tagsFilter = this.getTags
      this.filtersTemp.tagsFilter = this.tagsFilter
      this.fetchMaterialMasterData(1)
      this.closeDrawer()
    },
    resetFiltersFromState () {
      this.searchKeyWord = this.getFilters.searchKeyWord ?? ''
      this.leadtime = { ...this.getFilters.lead } ?? {}
      this.effectiveDate = { ...this.getFilters.date } ?? {}
      this.customListItmes = { ...this.getFilters.customListItmes } ?? {}
      this.filtersTemp.customListItmes = { ...this.getFilters.customListItmes } ?? {}
    },
    changeView (view) {
      if (this.view !== view) {
        this.$router.push(`/materialmaster/1?view=${view}`)
      }
    },
    selectPage (pageNumber) {
      this.pageNumber = pageNumber
      this.$router.push(`/materialmaster/${pageNumber}?view=${this.view}`)
      // this.fetchMaterialMasterData()
    },
    updateList (updateObject) {
      const updatedMaterial = this.checkMaterialEditPermission([updateObject.data])[0]
      const oldMaterial = this.materialMasterData[updateObject.index]
      if (oldMaterial && oldMaterial.blob_reference_key === updatedMaterial.blob_reference_key) {
        updatedMaterial.thumbnailUrl = oldMaterial.thumbnailUrl
      }
      this.$set(this.materialMasterData, updateObject.index, updatedMaterial)
      if (!oldMaterial || oldMaterial.blob_reference_key !== updatedMaterial.blob_reference_key) {
        this.loadAllThumbnails()
      }
    },
    downloadCsvData () {
      const filter = {
        type: this.view,
        jump: 0,
        perPage: 1000,
        searchKeyword: this.searchKeyWord
          ? `%${this.searchKeyWord}%`
          : undefined,
        tagId: this.tagsFilter.length
          ? this.tagsFilter[this.tagsFilter.length - 1]?.id
          : undefined,
        materialTypeId: this.selectedType?.id ?? undefined,
        customListItmes: this.customListItmes
          ? this.customListItmes
          : undefined,
        effectiveDate: this.effectiveDate,
        leadtime: this.leadtime,
        resourseStatusId:
            this.view === 'resource'
              ? this.selectedStatus?.id ?? undefined
              : undefined
      }
      const materialData = []
      const templateVersions = {}
      const formFields = {}
      Promise.allSettled([GetMaterialMasterData(filter, true, undefined, this.isExternalCollaborator), GetAllformFieldsOfAllVersionsByFormTypeId(config.STANDARD_MATERIAL_FORM.form_type, this.isOnProjectLevel)])
        .then(([material, template]) => {
          material = material.value?.core_material_master
          template = template.value
          for (const version of template.core_form_templates[0]?.template_versions) {
            // const versionId = version.id
            for (const item of version.template_fields) {
              if (item.caption === 'Created By' || item.caption === 'Created On' || item.caption === 'Updated By' || item.caption === 'Updated On' || item.caption === 'Due Date' || item.caption === 'Project Id') {
                continue
              } else if (templateVersions[item.field_id] && templateVersions[item.field_id].includes(item.caption.trim())) {
              } else if (templateVersions[item.field_id]) {
                templateVersions[item.field_id] += '/' + item.caption
              } else {
                templateVersions[item.field_id] = item.caption
              }
            }
          }
          for (const fieldId in templateVersions) {
            formFields[templateVersions[fieldId]] = '--'
          }
          for (const item of material) {
            const data = {}
            data[this.view === 'resource' ? 'Resourse ID' : 'Material ID'] = item.custom_material_id ?? ' --'
            data[this.view === 'resource' ? 'Resourse Name' : 'Material Name'] = item.material_name ? `"${item.material_name.replaceAll('"', '')}"` : '--'
            data.Description = item.material_description ? `"${item.material_description}"` : '--'
            data['Product Code'] = item.material_product_code?.product_code ? `"${item.material_product_code?.product_code }"` : '--'
            data['ERP Id'] = item.erp_material_id ? `"${item.erp_material_id }"` : '--'
            data['Gross Weight'] = item.gross_weight ?? ' --'
            data[this.view === 'resource' ? 'Resourse Group' : 'Material Group'] = (this.view === 'resource' ? item.resource_group_details?.name : item.material_group_details?.name) ?? '--'
            data.Inventory = item.inventory ?? ' --'
            data['Lead Time'] = item.lead_time ?? ' --'
            data['Storage Location'] = item.material_storage_location?.name ? `"${item.material_storage_location?.name }"` : '--'
            data['PLM Id'] = item.plm_material_id ?? ' --'
            data['PLM Record Id'] = item.plm_record_id ?? ' --'
            data['Effective Date'] = item.effective_date ?? ' --'
            data['Unit Cost'] = item.unit_cost ?? ' --'
            data['Unit Of Measurement'] = item.material_unit_details?.name ? `"${item.material_unit_details?.name}"` : '--'
            data['Unit Sale Price'] = item.unit_sale_price ?? ' --'
            data['Weight Unit'] = item.material_weight_details?.name ?? ' --'
            data.Source = item.material_source.source ?? ' --'
            data.Status = item.material_status.status ?? '--'
            if (item.tag_materials.length > 0) {
              item.tag_materials.forEach((tag) => {
                data.Tags = (data.Tags === '--' && !tag.tag?.name) ? '--' : `"${(data.Tags ?? '').replaceAll('"', '') + tag.tag?.name + ', ' }"`
              })
            } else {
              data.Tags = data.Tags || '--'
            }
            if (item.material_document_associations.length > 0) {
              item.material_document_associations.forEach((doc) => {
                data.Documents = (data.Documents === '--' && !doc.core_document?.doc_name) ? '--' : `"${(data.Documents ?? '').replaceAll('"', '') + doc.core_document?.doc_name + ', ' }"`
              })
            } else {
              data.Documents = data.Documents || '--'
            }
            Object.assign(data, formFields)
            const form = item.core_form
            // const versionId = form?.template_version_id

            for (const md of form?.forms_metadata_by_id ?? []) {
              const field = templateVersions[md.field_id]
              data[field] = `"${
                         md.string_value ??
                         md.time_value?.split('+')[0] ??
                         md.int_value ??
                         md.date_value ??
                         md.bool_value ??
                         md.point_value ??
                         md.string_value ?? '--'}"`
            }

            for (const configData of form?.forms_config_lists ?? []) {
              const field = templateVersions[configData.field_id]
              data[field] = `"${(configData.form_config_list || []).map((item) => item.value).join(', ') || '--'}"`
            }
            materialData.push(data)
          }
          arrayToCsv(materialData, [], this.view === 'resource' ? 'Resource Data.csv' : 'materialMasterData.csv')
        })
        .catch((err) => {
          console.log({ err })
        })
    },
    openImportModal () {
      this.importMaterialModal = true
    },
    closeImportModal () {
      this.importMaterialModal = false
    },
    materialCreated () {
      this.createNew = false
      this.fetchMaterialMasterData(0)
    },
    async fetchMaterialMasterData (number, updateFilters = true) {
      if (updateFilters) {
        this.updateFilters({
          searchKeyWord: this.searchKeyWord,
          date: this.effectiveDate,
          lead: this.leadtime,
          customListItmes: this.customListItmes,
          tagsFilter: this.tagsFilter
        })
      }
      const searchId = this.$route?.params?.materialId
      if (searchId) {
        this.searchKeyWord = searchId
      }
      const pageNumber = number || JSON.parse(this.$route?.params?.pageNumber ?? 1)
      this.pageNumber = pageNumber
      const EXTERNAL_SEARCH_TENANT_ID = '7521c9ab-ba01-4c4c-9b05-facc83ef04eb'
      const isExternalSearchTenant = this.openTenantId === EXTERNAL_SEARCH_TENANT_ID

      const loader = new Loader('.material-master-table')
      loader.show()
      this.materialMasterData = []

      try {
      // 5. Branching logic for External vs GraphQL search
        if (isExternalSearchTenant && this.searchKeyWord && this.view === 'material') {
          const res = await searchExternalMaterials(this.searchKeyWord)
          const externalResponse = res.externalResponse || res
          this.materialMasterData = this.transformExternalResults(externalResponse)
          this.totalCount = externalResponse.total_count || 100
        } else {
          const filter = {
            type: this.view,
            jump: (pageNumber - 1) * this.perPage,
            perPage: this.perPage,
            searchKeyword: this.searchKeyWord ? `%${this.searchKeyWord}%` : undefined,
            tagId: this.tagsFilter.length ? this.tagsFilter[this.tagsFilter.length - 1]?.id : undefined,
            customListItmes: this.customListItmes || undefined,
            effectiveDate: this.effectiveDate,
            leadtime: this.leadtime,
            resourseStatusId: this.view === 'resource' ? (this.selectedStatus?.id ?? undefined) : undefined
          }
          const res = await GetMaterialMasterData(
            filter,
            undefined,
            this.selectedSort,
            this.isExternalCollaborator
          )
          this.materialMasterData = this.checkMaterialEditPermission(res.core_material_master || [])

          this.totalCount = res.core_material_master_aggregate?.aggregate?.count || 0
          // Load thumbnails after data is fetched
          this.loadAllThumbnails()
        }
      } catch (err) {
        console.error('Fetch Material Master Error:', err)
        alert('Something went wrong while fetching data.')
      } finally {
        loader.hide()
      }
    },
    ...mapMutations('tag', ['addNewTag', 'updateTags', 'clearAllTags']),
    toggleFilters () {
      this.showFilters = !this.showFilters
    },
    toggleDrawer (event) {
      if (!this.drawer) {
        this.openDrawer()
      } else {
        this.closeDrawer()
      }
    },
    openDrawer () {
      this.tagsFilter = JSON.parse(JSON.stringify(this.filtersTemp.tagsFilter))
      this.customListItmes = { ...this.filtersTemp.customListItmes }
      this.clearAllTags()
      for (const tag of this.tagsFilter) {
        this.addNewTag(tag)
      }
      this.clear = false
      this.drawer = true
      this.$nextTick(() => {
        this.$refs.drawer.focus()
      })
    },
    closeDrawer () {
      this.drawer = false
      this.resetTempFilters()
    },
    resetTempFilters () {
      this.filtersTemp = JSON.parse(JSON.stringify({
        searchKeyWord: this.searchKeyWord,
        customListItmes: this.customListItmes,
        leadtime: this.leadtime,
        effectiveDate: this.effectiveDate,
        tagsFilter: this.tagsFilter
      }))
      this.clear = true
    },
    cancelFilter () {
      this.closeDrawer()
      this.resetTempFilters()
    },
    addCusListFilters (filters) {
      this.filtersTemp.customListItmes = filters
    },
    getResourseStatus () {
      ResourceState().then((res) => {
        this.resourceStateValues = res.custom_list_values.map((item) => {
          return {
            name: item.name,
            id: item?.id,
            label: 'Resource Status'
          }
        })
        this.resourceStateValues.unshift({
          name: 'Not Selected',
          id: -1,
          label: 'Resource Status'
        })
      })
    },
    addResourceSatatus (status) {
      if (status.id === -1) {
        this.selectedStatus = {}
      } else {
        this.selectedStatus = status
      }
    },
    updatedleadTimeTo (e) {
      this.filtersTemp.leadtime.to = e.target.value
    },
    updatedleadTimeFrom (e) {
      this.filtersTemp.leadtime.from = e.target.value
    },
    updateEffectiveDateTo (e) {
      this.filtersTemp.effectiveDate.to = e.target.value
    },
    updateEffectiveDateFrom (e) {
      this.filtersTemp.effectiveDate.from = e.target.value
    },
    loadAllThumbnails () {
      const S3ThumbNailObjects = []
      this.materialMasterData.map((item) => {
        if (item.blob_reference_key) {
          S3ThumbNailObjects.push({
            fileName: 'thumbnail.jpg',
            S3Key: item.blob_reference_key
          })
        }
      })
      generateS3DownloadingUrl({
        S3Objects: S3ThumbNailObjects
      }).then((res) => {
        const thumbnailMap = {}
        for (const thumbnail of res.url) {
          thumbnailMap[thumbnail.S3Key] = thumbnail.url
        }
        for (const material of this.materialMasterData) {
          const blobkey = material.blob_reference_key
          const url = thumbnailMap[blobkey]
          if (url) {
            material.thumbnailUrl = url
          }
        }
        this.materialMasterData = [...this.materialMasterData]
      })
        .catch((err) => {
          console.log(err)
        })
    },
    keyPress (e) {
      if (!this.drawer) { return }
      if (e instanceof KeyboardEvent && e.code === 'Escape') {
        this.cancelFilter()
      } else if (e instanceof KeyboardEvent && e.code === 'Enter') {
        this.applyFilter()
      }
    },
    checkMaterialEditPermission (materialList) {
      if (this.view === 'resource') {
        return materialList
      } else {
        return materialList.map((material) => {
          if (!material.ongoing_lifecycle_workflow_id) {
            material.canEdit = true
            return material
          }
          if (this.user.tenantLevelRole === 'ADMIN' && config.MATERIAL_STATUS_INVERTED_MAP.ACTIVE === material.status) {
            material.canEdit = true
            return material
          }
          for (const assignee of material.ongoing_lifecycle_workflow?.current_instance_step?.instance_step_assignees ?? []) {
            if (assignee.user_id === this.user.userId && config.MATERIAL_STATUS_INVERTED_MAP.ACTIVE === material.status) {
              material.canEdit = true
              return material
            }
          }
          for (const member of material.ongoing_lifecycle_workflow?.current_instance_step?.workflow_step?.core_user_group?.core_user_group_members ?? []) {
            if (member.user_id === this.user.userId && config.MATERIAL_STATUS_INVERTED_MAP.ACTIVE === material.status) {
              material.canEdit = true
              return material
            }
          }
          return material
        })
      }
    }
  },
  mounted () {
    this.resetFiltersFromState()
    if (
        this.$route.query?.view === 'material' ||
        this.$route.query?.view === 'resource'
    ) {
      this.view = this.$route.query?.view
    }
    this.fetchMaterialMasterData()
    this.getResourseStatus()
  },
  created () {
    // this.updateOnSearch = debounce(this.fetchMaterialMasterData.bind(null, 1, false), 300)
    document.body.addEventListener('keydown', this.keyPress)
  },
  watch: {
    // '$store.state.tag.tags' () {
    //   this.fetchMaterialMasterData(1, false)
    // },
    '$route.params.pageNumber' () {
      this.fetchMaterialMasterData()
    },
    '$route.query.view' (newVal, oldVal) {
      if (newVal === oldVal) return
      // If we are just appending the default view to the URL, don't reset data
      if (!oldVal && newVal === 'material' && this.view === 'material') return
      this.view = newVal || 'material'
      this.clearAllData()
      this.resetFiltersFromState()
      this.fetchMaterialMasterData(1)
    },
    selectedSort (value) {
      if (value === '0') return
      this.fetchMaterialMasterData()
    }
  },
  beforeDestroy () {
    document.body.removeEventListener('keydown', this.keyPress)
    this.clearAllTags()
    this.updateFilters({})
  }
}
</script>

  <style lang="scss" scoped>
    .sort {
    height: 2em;
    width: 10rem;
    margin: 0 10px 0 10px;
    // margin-left: 2px;
    font-size: var(--text-base);
    background-color: var(--brand-light-color);
    line-height: 1;
    border: 1px solid var(--brand-color);
    border-radius: 4px;
    padding: 4px 12px;
    }
  .material-master {
    padding-bottom: 0;
    .header-container {
        display: flex;
        gap: 5px;
        header {
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid var(--border);
        }
    }
    .filter-options {
        margin: 10px 0 15px 0;
        margin-left: auto;  /* Push it to the right */
        display: flex; /* Ensure buttons inside align properly */
        align-items: center;
    }
    &-bar {
      height: 60px;
      margin: -12px;
      margin-bottom: 0;
      background: var(--bg-color);
      border-bottom: var(--border);
    }
    padding-bottom: 10px;
    margin-bottom: 50px;
  }
  .toggle {
    font-size: 1em;
    padding: 0.5em 1.2em;
    color: var(--black);
    font-weight: 500;
    border: none;
    box-shadow: 0.1em 0.1em 0.1em rgba(0, 0, 0, 0.25);
    background-color: var(--side-bar-color);

    &:active {
      box-shadow: inset 0.2em 0.2em 0.2em rgba(0, 0, 0, 0.25);
    }

    &-left {
      border-radius: 0.3rem 0px 0px 0.3rem;
    }

    &-right {
      border-radius: 0px 0.3rem 0.3rem 0px;
    }

    &-selected {
      background-color: var(--brand-color);
    }
  }
  .drawer {
  //   position: fixed;
    // top: 60px;
  //   background-color: #f8f4f0;
  //   box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    padding: 20px;
  //   border-radius: 5px;
  //   max-width: 80%;
    width: 400px;
  //   overflow: auto;
    z-index: 1000;
  //   opacity: 0;
  //   visibility: hidden;
  //   transition: opacity 0.3s, visibility 0.3s;
  }
  .drawer.open {
    opacity: 1;
    visibility: visible;
  }
  .filter-by {
    margin-top: 15px;
    margin-bottom: 8px;
  }
  .input-group-ind {
    color: var(--text-color);
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 1rem;
    input,
    select,
    textarea {
      border: 1px solid #3b3b3b77;
      display: block;
      width: 100%;
      border-radius: 0.285em;
      font-size: 1em;
      padding: 0.85em;
      background-color: transparent;
      &::placeholder {
        color: var(--text-color);
        opacity: 0.5;
      }
      &:focus {
        box-shadow: 0 0 0 1px var(--brand-color-1);
      }
    }
    label {
      display: block;
      width: 100%;
      font-size: 1em;
      margin-bottom: 0.2em;
    }
  }
  .selectedOne {
    background-color: var(--brand-light-color) !important;
  }
  .button-box {
    background-color: #f8f4f0;
    position: sticky;
    bottom: -20px;
    display: flex;
    align-items: center;
  }
  .addfilter {
    position: relative;
    overflow: visible;
    &-badge {
      position: absolute;
        top: 0;
        right: 10px;
        transform: translate(50%, -50%);
        border-radius: 50%;
        background-color:var(--brand-color-1);
        z-index: 2;
        padding: 3px;
    }
    &-ping {
        animation: ping 1.5s ease-in-out infinite both;
        padding: 10px;
        background-color:black;
        border-radius: 50%;
        transform: translate(50%, -50%);
        position: absolute;
        top: 0;
        right: 10px;
        z-index: 1;
      }
  }

  @keyframes ping {
    0% {
      transform: translate(50%, -50%);
      padding: 5px;
      opacity: 1;
    }
    100% {
      transform: translate(50%, -50%);
      padding: 18px;
      opacity: 0;
    }
  }
  </style>
